/* eslint-disable react/jsx-pascal-case */
import * as React from 'react';
import Box from '@mui/material/Box';
import { styled, ThemeProvider, createTheme } from '@mui/material/styles';
import Divider from '@mui/material/Divider';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import Paper from '@mui/material/Paper';
import KeyboardArrowDown from '@mui/icons-material/KeyboardArrowDown';
import Home from '@mui/icons-material/Home';
import styles from './AyurvedicEncyclopedia.module.css';
import { AYURVEDA_ENCYCLOPEDIA_DATA } from '../../Datasets/AyurvedaEncyclopedia';
import SearchHeader from '../../components/SearchHeader/SearchHeader';
import C1_Overview from './Chapters/C1_Overview';
import C2_TheHumanUniverse from './Chapters/C2_TheHumanUniverse';
import AyurvedaIllustration from '../../assets/images/ayurveda-manthan1-7.webp'
import { Link } from 'react-router-dom';

const sections = AYURVEDA_ENCYCLOPEDIA_DATA;
const FireNav = styled(List)({
  // '& .MuiListItemButton-root': {
  //   paddingLeft: 24,
  //   paddingRight: 24,
  // },
  '& .MuiListItemText-root': {
    flex: "1 1 auto",
    minWidth: 0,
    marginTop: "4px",
    marginBottom: "4px",
    width: "100%"
  },
  '& .MuiButtonBase-root-MuiListItemButton-root': {
    margin: "0 !important",
    color: "inherit",
    display: "flex",
    alignItems: "flex-start",
    position: "relative",
    textDecoration: "none",
    minWidth: 0,
    boxSizing: "border-box",
    textAlign: "left",
    transition: "background-color 150ms cubic-bezier(0.4, 0, 0.2, 1) 0ms",
    cursor: "pointer",
    textTransform: "uppercase !important",
    backgroundColor: "black !important",
  },
  '& .MuiListItemIcon-root': {
    minWidth: 0,
    // marginRight: 16,
  },
  '& .MuiSvgIcon-root': {
    fontSize: 20,
  },
  '& .css-rb0499': {
    padding: "0 !important",
  }
});

export default function AyurvedicEncyclopedia() {
  const [open, setOpen] = React.useState(true);
  const [width, setWidth] = React.useState("270px");
  const [clickedChapter, setClickedChapter] = React.useState(""); // State to store the clicked chapter

  React.useEffect(() => {
    if (window.innerWidth <= 500) {
      setOpen(false);
      setWidth(`${window.innerWidth}px`);
    }
  }, []);

  // Event handler for when a chapter is clicked
  const handleChapterClick = (chapterName) => {
    setClickedChapter(chapterName); // Update the state with the clicked chapter name
  };
  return (
    <div className={styles.cont}>

      <Box sx={{ display: 'flex', minWidth: width }}>
        <ThemeProvider
          theme={createTheme({
            components: {
              MuiListItemButton: {
                defaultProps: {
                  disableTouchRipple: true,
                },
              },
            },
            palette: {
              mode: 'dark',
              primary: { main: 'rgb(102, 157, 246)' },
              background: { paper: 'rgb(5, 30, 52)' },
            },
          })}
        >
          <Paper elevation={0} sx={{ width: width, backgroundColor: "#003f03", color: "white", borderRadius: "0" }}>
            <FireNav component="nav" disablePadding>
              <ListItemButton component="a" href="#customized-list">
                <ListItemText
                  sx={{ my: 0, color: "white" }}
                  primary="Ayurvedic Encyclopedia"
                  primaryTypographyProps={{
                    fontSize: 20,
                    fontWeight: 'medium',
                    letterSpacing: 0,
                  }}
                />
              </ListItemButton>
              <Divider />
              <ListItem component="div" disablePadding>
                <ListItemButton sx={{ height: 56 }}>
                  <ListItemIcon>
                    <Home color="white" />
                  </ListItemIcon>
                  <Link to='/'>
                    <ListItemText
                      color='white'
                      primary="Home Page"
                      primaryTypographyProps={{
                        color: 'white',
                        fontWeight: 'medium',
                        variant: 'body2',
                      }}
                    />
                  </Link>
                </ListItemButton>

              </ListItem>
              <Divider />
              <Box
                sx={{
                  bgcolor: open ? 'rgba(71, 98, 130, 0.2)' : null,
                  pb: open ? 2 : 0,
                }}
              >
                <ListItemButton
                  alignItems="flex-start"
                  onClick={() => setOpen(!open)}
                  sx={{
                    pt: 2.5,
                    pb: 2.5,
                    '&:hover, &:focus': { '& svg': { opacity: open ? 1 : 0 } },
                  }}
                >
                  <ListItemText
                    primary="Table of Contents"
                    primaryTypographyProps={{
                      fontSize: 15,
                      fontWeight: 'medium',
                      lineHeight: '20px',
                      mb: '2px',
                    }}
                    secondaryTypographyProps={{
                      noWrap: true,
                      fontSize: 12,
                      lineHeight: '16px',
                      color: open ? 'rgba(0,0,0,0)' : 'rgba(255,255,255,0.5)',
                    }}
                    sx={{ my: 0 }}
                  />
                  <KeyboardArrowDown
                    sx={{
                      mr: -1,
                      opacity: 0,
                      transform: open ? 'rotate(-180deg)' : 'rotate(0)',
                      transition: '0.2s',
                    }}
                  />
                </ListItemButton>
                {open &&
                  sections.map((item) => (
                    <ListItemButton
                      key={item.name}
                      sx={{ py: 0, minHeight: 32, color: 'rgba(255,255,255,.8)', display: "flex", flexDirection: "column", alignSelf: "start", width: "100%", padding: ".5rem 1rem" }}
                    >
                      <ListItemText
                        style={{ alignSelf: "start" }}
                        primary={item.name}
                        primaryTypographyProps={{ fontSize: 14, fontWeight: 'medium', alignSelf: "start", backgroundColor: "#0000005e", width: "100%", padding: ".5rem 1rem" }}
                      />
                      {item.chapters.map((chapter) => (
                        <div key={chapter.name} style={{ alignSelf: "start", width: "100%" }}>
                          <ListItemButton sx={{ py: 0, minHeight: 32, color: 'rgba(255,255,255,.8)', display: "flex", flexDirection: "column" }}>
                            <ListItemText
                              primary={chapter.name}
                              primaryTypographyProps={{ fontSize: 14, fontWeight: 'medium' }}
                              onClick={() => handleChapterClick(chapter.name)}

                            />
                          </ListItemButton>
                          {Object.keys(chapter.subChapters).map((subChapter) => (
                            <div key={subChapter} style={{ backgroundColor: "rgb(16, 104, 37)" }}>
                              <ListItemButton sx={{ py: 0, minHeight: 32, color: 'rgba(255,255,255,.8)' }}>
                                <ListItemText
                                  primary={chapter.subChapters[subChapter]}
                                  primaryTypographyProps={{ fontSize: 14, fontWeight: 'medium' }}
                                />
                              </ListItemButton>
                            </div>
                          ))}
                        </div>
                      ))}
                    </ListItemButton>
                  ))}
              </Box>
            </FireNav>
          </Paper>
        </ThemeProvider>
      </Box>
      <div className={styles.encycCont}>
        <div className={styles.searchCont}>
          <SearchHeader placeholder="Search Ayurvedic Encyclopedia" style={{ position: "relative !important" }} />
        </div>
        <div>
          {clickedChapter === "" && (
            <div className={styles.front}>
              <h1>Welcome to the World of Ayurveda</h1>
              <h3>Natural Secrets to Healing, Prevention & Longevity</h3>
              <img src={AyurvedaIllustration} alt="Manthan" />
            </div>
          )}

          {clickedChapter === "Overview" && <C1_Overview />}
          {clickedChapter === "The Human Universe" && <C2_TheHumanUniverse />}
        </div>
      </div>
    </div>
  );
}
